<template>
  <div id="app">
    <CallScreen v-if="activePermission" :video-mode-call="videoScene" />
    <PermissionScreen v-if="!activePermission" />
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import CallScreen from './components/CallScreen.vue'
import PermissionScreen from './components/PermissionScreen.vue'
import { snakeToCamel } from './utils/snakeToCamel'

export default {
  name: 'App',
  components: {
    CallScreen,
    PermissionScreen,
  },

  data() {
    return {
      activePermission: false,
    }
  },

  computed: {
    ...mapState({
      activeVideo: state => state.call.activeVideo,
      callStatus: state => state.call.callStatus,
      isCaller: state => state.call.isCaller,
    }),

    videoScene() {
      if (!this.isCaller) {
        return this.activeVideo
      } else {
        if (this.callStatus) {
          return false
        } else {
          return this.activeVideo
        }
      }
    },
  },

  mounted() {
    this.initializeApp()
    setInterval(this.permission, 1000)
  },

  methods: {
    permission() {
      if (!this.activePermission) {
        navigator.mediaDevices
          .getUserMedia({ audio: true, video: this.activeVideo })
          .then(stream => this.successCallback(stream))
          .catch(err => this.errorCallback(err))
      }
    },
    successCallback() {
      this.activePermission = true
    },
    errorCallback(err) {
      console.log(err)
      this.activePermission = false
    },
    ...mapActions(['getMainUserData', 'getUserData']),
    ...mapMutations(['setInitialStore', 'statusVideo']),

    initializeApp() {
      const searchParams = this.getSearchParams()
      const paramsObject = this.getParamsObject(searchParams)
      this.statusVideo({ data: JSON.parse(paramsObject.videoCall) })
      this.setInitialStore(paramsObject)
      this.getMainUserData()
      this.getUserData()
    },

    getSearchParams() {
      const uri = new URL(window.location.href)
      return uri.searchParams
    },

    getParamsObject(searchParams) {
      const searchParamsObject = {}
      for (let pair of searchParams.entries()) {
        const key = snakeToCamel(pair[0])
        searchParamsObject[key] = pair[1]
      }
      return searchParamsObject
    },
  },
}
</script>

<style lang="scss">
@import 'assets/styles/icons';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}
body {
  margin: 0;
  padding: 0;
}
</style>
